export default {
  lang: 'ru',

  nav: {
    home:    'введите код',
    prizes:  'Призы',
    about:   'Об акции',
    faq:     'Помощь',
    profile: 'Профиль',
  },

  codePage: {
    title:              'Акция завершена',
    subtitle:           'Регистрируй больше кодов \n и увеличивай шансы получения призов!',
    placeholder:        'Введите код',
    placeholderAnother: 'Введите другой код',
    mainImg: new URL('../assets/img/main_img_ru_3.webp', import.meta.url).href,
  },

  playPage: {
    title:          'Код успешно зарегистрирован',
    subtitle:       'Открывай шкафчики - получай призы!',
    spinBtn:        'Открыть шкафчик',
    spinning:       'Крутится...',
    won:            'Поздравляем! Ваш приз:',
    claimBtn:       'Получить приз',
    btnEnterCode:   'Ввести другой код',
    btnMoreDetails: 'Подробнее',
    btnEnterName:   'Ввести имя',
    btnMerchandiseDetails:   'Выбрать пункт выдачи заказа',
    emptyPrizeDesc: 'Поздравляем! Ты получил \n шанс выиграть автомобиль, \n игровую приставку или \n путевку во Вьетнам!',
  },

  customizationPage: {
    title:         'Введите имя',
    placeholder:   'Введите имя',
    label:         'Введите имя',
    ariaShowFront: 'Показать лицо',
    ariaShowBack:  'Показать спину',
    sizesBtn:      'Таблица размеров',
    nextBtn:       'Далее',
  },

  deliveryPage: {
    title:               'Заполните данные',
    fullNamePlaceholder: 'ФИО получателя',
    fullNameLabel:       'ФИО получателя',
    phoneLabel:          'Номер телефона получателя',
    addressTitle:        'Адрес доставки',
    changeAddress:       'Изменить адрес',
    selectPickup:        'Выбрать \n пункт выдачи заказа',
    confirmBtn:          'Подтвердить',
    phoneErrorEmpty:     'Введите номер телефона',
    phoneErrorInvalid:   'Невалидный номер',
  },

  claimPage: {
    title:             'Оформить получение',
    fullName:          'Имя и фамилия',
    phone:             'Номер телефона',
    email:             'Email',
    pickupTitle:       'Выберите пункт выдачи',
    selectPoint:       'Выбрать на карте',
    submit:            'Подтвердить',
    success:           'Заявка отправлена',
    mapLoading:        'Карта загружается...',
    noPoints:          'Пункты выдачи не найдены',
    searchTitle:       'Поиск',
    searchPlaceholder: 'Искать на карте',
    labelIndex:        'Индекс',
    labelAddress:      'Адрес',
    pickupBtn:         'Заберу отсюда',
    labelLandmark:     'Ориентир',
  },

  prizePage: {
    title:        'Призы',
    subtitle:     'Все призы, которые можно выиграть',
    empty:        'Призы скоро появятся',
    weeklyTitle:  'Каждую неделю разыгрываем',
    dailyTitle:   'ежедневные призы',
    carName:      'Автомобиль',
    carModel:     'BYD Yuan Up',
    consoleName:  'Приставка',
    consoleModel: 'Sony PlayStation 5 PRO',
    vietnamName:   'Сертификат на поездку во Вьетнам',
    tshirtName:   'Футболка с твоим именем',
    certName:     'Сертификат SETANTA SPORTS',
    mainImg:    new URL('../assets/img/prizes/prize_every_weekly_ru.webp', import.meta.url).href,
    detailsBtn:   'Подробнее',
    tshirtDetail: {
      name:        'ФУТБОЛКА ИГРОКА №12 С ТВОИМ ИМЕНЕМ',
      description: 'Получая её ты становишься частью уникальной команды игроков №12, которая охватит всю страну. \n \n  Напиши своё имя, выбери размер, оформи доставку — и мы позаботимся о том, чтобы именная футболка оказалась у тебя. 😊🔥',
    },
    certDetail: {
      name:        'Подписка на 1 месяц на стриминговую платформу Setanta Sports',
      description: 'В рамках акции «C PEPSI ты в игре!» участники могут выиграть промокод на подписку Setanta Sports — стриминговую ОТТ-платформу с доступом к эксклюзивному спортивному контенту. На платформе доступны прямые трансляции футбольных чемпионатов (Английская Премьер-лига, Серия А, Лига 1, Бундеслига, Ла-Лига), UFC, Формулы-1, NBA, NHL, тенниса и других популярных спортивных событий.',
    },
    beachDetail: {
      name:        'Поездка во вьетнам',
      description: 'Сертификат предоставляет возможность отправиться в туристическую поездку на двоих, во Вьетнам. \n \n Для использования сертификата необходимо заключить договор до 31.12.2026, а совершить поездку — до 31.12.2027. Даты путешествия победитель выбирает самостоятельно с учётом наличия мест и рейсов.',
    },
    done: 'из',
  },

  aboutPage: {
    title:          'С Pepsi \n ты в игре!',
    subtitle:       'С 22 мая по 23 августа 2026',
    textLink:       'подробнее об участии',
    watchLink:       'Смотреть',
    textMorePizes:  'и много других призов',
    prizeEveryday:  'Каждый день \n с 22 мая по 22 августа разыгрываем:',
    prizeEveryweek: 'Каждую неделю разыгрываем главные призы:',
    rulesTitle:     'Как участвовать в акции?',
    step1Label:     'Шаг 1',
    step1Text:      'Купи акционную бутылку Pepsi с жёлтой крышкой',
    step2Label:     'Шаг 2',
    step2Text:      'Введи код под крышкой',
    step3Label:     'Шаг 3',
    step3Text:      'Открывай шкафчики и участвуй в розыгрыше',
    step3Img: new URL('../assets/img/about/step_3_ru.png', import.meta.url).href,
    tshirtName:  'Футболка игрока №12 с твоим именем',
    certName:    'Подписка на 1 месяц на стриминговую платформу Setanta Sports',
    ballName:    'Футбольный мяч',
    bagName:     'Термосумка',
    cupName:     'Стакан-хамелеон',
    scarfName:   'Брендированный шарф',
    uzumName:    'UZUM на 10 000, \n 25 000 и 50 000 сум',
    uzumName10:    'UZUM на 10 000',
    uzumName25:    'UZUM на 25 000',
    uzumName50:    'UZUM на 50 000',
    carName:     'Автомобиль \n BYD Yuan Up',
    consoleName: 'Игровая приставка Sony PlayStation 5',
    bichName:    'Сертификат на поездку во Вьетнам',
    watchingName:    'Каждое воскресенье розыгрыши в прямом эфире  в 19.30.',
    uzumImg: new URL('../assets/img/prizes/prize_uzum_ru.webp', import.meta.url).href,
    uzumImg10: new URL('../assets/img/prizes/prize_uzum_ru_10.webp', import.meta.url).href,
    uzumImg25: new URL('../assets/img/prizes/prize_uzum_ru_25.webp', import.meta.url).href,
    uzumImg50: new URL('../assets/img/prizes/prize_uzum_ru_50.webp', import.meta.url).href,
    weekendImg: new URL('../assets/img/prizes/prize_every_weekend_ru.webp', import.meta.url).href,
  },

  faqPage: {
    title:          'Помощь',
    empty:          'Вопросы скоро появятся',
    footerQuestion: 'Не нашли ответ на вопрос?',
    footerAnswer:   'Закройте мини-приложение и напишите нам через раздел «Помощь» в боте.',
  },

  profilePage: {
    title:       'профиль',
    noAuth:      'Вы не авторизованы',
    prizes:      'Мои призы',
    noPrizes:    'Призов пока нет',
    codesTitle:  'Мои коды',
    prizesTitle: 'Выигранные призы',
    openBtn:     'Открыть',
    openTitle:   'Открывай шкафчики и выигрывай призы',
    copyTitle:   'Cкопировать',
    copiedText:  'Cкопированo',
    noCodes:     'Вы еще не зарегистрировали ни один код',
    noPrizes:    'У вас еще нет призов',
  },

  certPage: {
    title:         'Сертификат SETANTA SPORTS',
    copyTitle:     'Cкопировать',
    copiedText:    'Ссылка скопирована',
    promoDate:     'Сроки действия промокода с 22 мая по 18 октября 2026.',
    newSubTitle:   'У вас нет активной подписки, и вы хотите приобрести ее по промокоду.',
    newSubSteps: [
      'Откройте <a href="https://app.setantasports.com/home" target="_blank">app.setantasports.com →</a> в своем браузере',
      'Авторизируйтесь или зарегистрируйтесь',
      'В правом верхнем углу экрана нажмите Аккаунт',
      'Перейдите в раздел Подписки и выберите нужную',
      'В Способе оплаты выберите банковскую карту и введите номер карты, срок действия, период, и трехзначный CVC-код, который размещается на оборотной странице карты',
      'Введите промокод в соответствующее поле и нажмите «Использовать».',
      'Нажмите «Оформить заказ», и подписка будет активирована.',
    ],
    existSubTitle: 'У вас уже есть активная подписка и вы хотите использовать промокод при следующем платеже.',
    existSubSteps: [
      'Откройте <a href="https://app.setantasports.com/home" target="_blank">app.setantasports.com →</a> в своем браузере',
      'Авторизируйтесь',
      'В правом верхнем углу экрана нажмите Аккаунт',
      'Перейдите в раздел Подписки',
      'При активной подписке нажмите «Применить промокод»',
      'Введите промокод и нажмите «Отправить»',
    ],
  },

  modals: {
    sizeChartTitle:   'Таблица размеров',
    sizeLabel:        'Размер',
    chestLabel:       'Обхват груди, см',
    waistLabel:       'Обхват талии, см',
    copyTitle:        'Cкопировать',
    copiedText:       'Скопирован',
    tshirtModalTitle: 'Футболка с твоим именем',
    compositionLabel: 'Cостав',
    compositionValue: '100% хлопок',
    trackLabel:       'Трек номер',
    trackCopied:      'Трек номер скопирован',
    pickupLabel:      'Отделение связи',
  },

  prizeCard: {
    detailsBtn:       'Подробнее',
    addAddressBtn:    'Добавить адрес',
    enterNameBtn:     'Ввести имя',
    moderationReason: 'Причина отклонения',
    statuses: {
      delivered:                 'Доставлено',
      customization_required:    'Ожидает оформления',
      moderation_pending:        'На модерации',
      moderation_approved:       'Передано в доставку',
      delivery_pending:           'Передано в доставку',
      moderation_declined:       'Отклонён',
      address_required:          'Ожидает оформления',
      delivery_created:          'Передано в доставку',
      sent_to_production:        'Передано в доставку',
      in_transit:                'В пути',
      ready_for_pickup:          'Готов к выдаче',
      delivery_failed:           'Ошибка доставки',
      cancelled:                 'Отменён',
    },
  },

  common: {
    loading:    'Загрузка...',
    error:      'Произошла ошибка. Попробуйте позже.',
    back:       'Назад',
    close:      'Закрыть',
    copyTitle:  'Cкопировать',
    copiedText: 'Скопировано',
  },

  error: {
    codePageTitle: 'Произошла ошибка',
    notUserTitle:  'доступно для зарегистрированных пользователей',
    warningCode: {
      title:   'Произошла ошибка',
      btnText: 'Попробовать ещё раз',
    },
    warningSpin: {
      title:   'Что-то пошло не так',
      btnText: 'Попробовать ещё раз',
    },
    errorCustom: {
      title:     'Что-то пошло не так',
      message:   'Пожалуйста, убедитесь что надпись на футболке соотвествует правилам',
      linkRules: 'Правила',
      btnText:   'Попробовать еще раз',
    },
    errorAddress: {
      title:   'Что-то пошло не так',
      message: 'Проверьте введённые данные и попробуйте ещё раз',
      btnText: 'Вернуться к вводу данных',
    },
    codeOutcome: {
      already_used:       'Этот код уже был использован',
      not_found:          'Код не найден. Проверьте правильность ввода',
      blocked:            'Код заблокирован',
      tooManyAttempts:    'Слишком много попыток. Попробуйте позже',
      daily_limit_reached: 'Превышен ежедневный лимит. Возвращайся завтра.',
    },
  },

  success: {
    title:        'Ваша Заявка отправлена',
    subtitle:     'Заявка на «{name}» отправлена на проверку, \n результат придёт в течение 72 часов',
    defaultName:  'Приз',
  },
  successMerch: {
    title:        'Заказ успешно оформлен',
    subtitle:     'Следите за статусом в личном кабинете',
    defaultName:  'Приз',
  },
  stockStatus: {
    notStartedTitle:    'Акция еще не началась',
    endedTitle:    'Акция завершена',
  },
}
